import { goto } from "$app/navigation";
import { isMobileAPISetup } from "$native/helpers";
import { loadTenants } from "$store/tenants";
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from '@capacitor/splash-screen';
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import { loadFeatureFlags } from "./shared";
import { initializeMobileStore } from "./stores/mobile.store";
import { SafeArea } from "capacitor-plugin-safe-area";


function addBackButtonHandler() {
	if (Capacitor.getPlatform() !== "android") {
		return;
	}

	try {
		CapacitorApp.addListener('backButton', ({ canGoBack }) => {
			if (!canGoBack) {
				CapacitorApp?.exitApp();
			} else {
				window.history.back();
			}
		});
	} catch (error) {
		console.error(error);
	}
}

async function setNativeInsetsForTailwind() {
	if (!Capacitor.isNativePlatform()) {
		return;
	}

	const safeAreaData = await SafeArea.getSafeAreaInsets();
	const { insets } = safeAreaData;

	for (const [key, value] of Object.entries(insets)) {
		document.documentElement.style.setProperty(
			`--safe-area-inset-${key}`,
			`${value}px`,
		);
	}
}

export async function initializeMobile() {
	setNativeInsetsForTailwind();
	
	if (!Capacitor.isNativePlatform()) {
		console.error('initializeMobile() called on non-native platform');
		return;
	}
	// Initiate sentry session replay integration
	// setupSentryReplay();
	// Listen for app ready
	await CapacitorUpdater.addListener('appReady', () => {
		// Double-check hiding splash here as well
		SplashScreen.hide();
	});

	try {
		// Inform the updater that the application is prepared to prevent reverting to the previous version 
		// in case an over-the-air update has just occurred.
		await CapacitorUpdater.notifyAppReady();
		console.log("App ready");
	} catch (error) {
		console.error(error);
	} finally {
		setTimeout(() => {
			SplashScreen.hide();
		}, 5000);
	}

	// Listen for deep links
	await CapacitorApp.addListener('appUrlOpen', (data) => {
		if (data.url) {
			const replaceValue = 'campuscommunity://';
			const url = data.url.replace(replaceValue, '');
			if (url?.length > 0) goto(url);
		}
	});

	// Get the versions and check if an update is available
	// const versions = await getVersion();
	// const needsUpdate = await isUpdateAvailable(versions);

	// // Check if the app is supported
	// const isAppSupported = await checkIfCurrentVersionIsSupported();

	// if (!isAppSupported) {
	// 	goto('/outdated-app');
	// 	console.info('App is not supported, redirecting to outdated-app, returning.');
	// 	return;
	// }

	// Initialize the mobile store with the versions and needsUpdate values
	// initializeMobileStore(versions, needsUpdate, isAppSupported, true);
	initializeMobileStore({
		builtin: { version: '1.0.0' },
		current: { bundle: { version: '1.0.0', id: '1.0.0', downloaded: '1.0.0', checksum: '1.0.0', status: 'pending' }, native: '1.0.0' },
		channel: { channel: 'dev' },
	}, false, true, true);

	const isApiSetup = isMobileAPISetup();
	loadTenants();

	if (isApiSetup) {
		await loadFeatureFlags();
	}

	addBackButtonHandler();

	// Check if the app is ready
	console.log('Hello from mobile.ts');
}
